// extracted by mini-css-extract-plugin
export var actions = "_4e-0";
export var actionsContainer = "_4e-7";
export var border = "_4e-1";
export var childFullHeight = "_4e-e";
export var collapse = "_4e-2";
export var content = "_4e-9";
export var contentChild = "_4e-d";
export var fullscreen = "_4e-b";
export var hasLeftRadius = "_4e-q";
export var headerContainer = "_4e-3";
export var headerRow = "_4e-5";
export var hidePadding = "_4e-a";
export var navCollapsedGap = "_4e-r";
export var noScrollX = "_4e-s";
export var noScrollY = "_4e-t";
export var noTopPadding = "_4e-o";
export var optOutTopPadding = "_4e-c";
export var outletContent = "_4e-k";
export var outletContentInner = "_4e-l";
export var outletLeadingPanel = "_4e-h";
export var outletLeadingPanelAttention = "_4e-i";
export var outletResizeDivider = "_4e-j";
export var outletSplit = "_4e-f";
export var outletSplitResizing = "_4e-g";
export var pageMain = "_4e-p";
export var pageOuter = "_4e-m";
export var pagePadding = "_4e-8";
export var profile = "_4e-u";
export var profileContainer = "_4e-v";
export var profileImage = "_4e-w";
export var profileMain = "_4e-x";
export var profileSubtitle = "_4e-z";
export var profileTitle = "_4e-y";
export var showLeftPadding = "_4e-n";
export var tabsPortalSlot = "_4e-6";
export var tabsWrapper = "_4e-4";
export var title = "_4e-10";